import React from 'react';
import { EmptyContentProps } from './types';

const ChatContentEmpty: React.FC<EmptyContentProps> = (props: EmptyContentProps) => {
    const { avatar, strings, person } = props;

    return (
        <div className="empty-state">
            <img className="avatar" src={avatar} />
            <span className="name">
                {strings.BOT_GREETINGS} <b>{person.firstName}</b>
            </span>
            <span>{strings.BOT_HOW_CAN_I_HELP_YOU_CHAT}</span>
        </div>
    );
};

export default ChatContentEmpty;
